/**
 * Fragebogen.class
 *
 * (c) notwenidges übel UG, Dimitri Preiß (preiss@notwenidges-uebel.de)
 */
import Cheet from './cheet';

export default class Fragebogen {
    config = {
        cheetItems: '[data-cheet-item]',
        cheetQuestion: '[data-cheet-question]',
        cheetTrack: '[data-cheet-track]',
        cheetRange: '[data-cheet-range]',
        cheetIndex: '[data-cheet-index]',
        cheetMax: '[data-cheet-max]',
        cheetAction: '[data-cheet-action]',
        cheetNext: '[data-cheet-next]',
        cheetBack: '[data-cheet-back]',
        cheetYes: '[data-cheet-yes]',
        cheetNo: '[data-cheet-no]',
        cheetMaybe: '[data-cheet-maybe]',
        cheetConclusion: '[data-cheet-conclusion]',
    };

    constructor(elem, config) {
        this.config = {...this.config, ...config};
        this.elem = elem;

        this.items = Array.from(this.elem.querySelectorAll(this.config.cheetItems));
        this.radios = Array.from(this.elem.querySelectorAll('[type="radio"]'));
        this.cheetTrack = this.elem.querySelector(this.config.cheetTrack) || false;
        this.cheetRange = this.elem.querySelector(this.config.cheetRange) || false;
        this.cheetIndex = this.elem.querySelector(this.config.cheetIndex) || false;
        this.cheetMax = this.elem.querySelector(this.config.cheetMax) || false;
        this.cheetAction = this.elem.querySelector(this.config.cheetAction) || false;
        this.cheetNext = this.elem.querySelector(this.config.cheetNext) || false;
        this.cheetBack = this.elem.querySelector(this.config.cheetBack) || false;
        this.cheetConclusion = this.elem.querySelector(this.config.cheetConclusion) || false;
        this.cheetNo = this.elem.querySelector(this.config.cheetNo) || false;
        this.cheetMaybe = this.elem.querySelector(this.config.cheetMaybe) || false;
        this.cheetYes = this.elem.querySelector(this.config.cheetYes) || false;

        this.active = 0;
        this.max = this.items.length;

        this.setStep();

        this.yes = 0;
        this.no = 0;
        this.maybe = 0;

        if (this.cheetTrack
            && this.cheetRange
            && this.cheetIndex
            && this.cheetMax
            && this.cheetAction
            && this.cheetNext
            && this.cheetBack) {
            this.init();
            this.registerEvent();
        }
    }

    init() {
        this.items.forEach((item) => {
            // eslint-disable-next-line no-param-reassign
            item.Cheet = new Cheet(item);

            item.addEventListener('change', () => {
                if (item.Cheet.isComplete()) {
                    this.enableNext();
                }
            });
        });

        this.cheetMax.innertext = this.max;
    }

    registerEvent() {
        this.cheetNext.addEventListener('click', (e) => {
            if (e.target.classList.contains('disabled')) {
                e.preventDefault();
            } else {
                this.nextCheet();
            }
        });

        this.cheetBack.addEventListener('click', (e) => {
            if (e.target.classList.contains('disabled')) {
                e.preventDefault();
            } else {
                this.prevCheet();
            }
        });
    }

    nextCheet() {
        // eslint-disable-next-line no-plusplus
        this.active++;
        this.items.forEach((elem) => elem.classList.add('d-none'));

        if (this.active >= 0 && this.active < this.max) {
            this.items[this.active].classList.remove('d-none');
            this.cheetAction.classList.remove('d-none');
            this.disableNext();

            if (this.active > 0) this.disableBack();
            if (this.items[this.active].Cheet.isComplete()) this.enableNext();
            this.setStep();
        } else {
            this.showConclusion();
        }
    }

    prevCheet() {
        // eslint-disable-next-line no-plusplus
        this.active--;
        this.items.forEach((elem) => elem.classList.add('d-none'));

        if (this.active >= 0 && this.active >= 0) {
            this.items[this.active].classList.remove('d-none');
            this.cheetAction.classList.remove('d-none');

            if (this.active > 0) this.disableBack();
            if (this.active === 0) this.enableBack();
            if (this.items[this.active].Cheet.isComplete()) this.enableNext();
            this.setStep();
        } else {
            this.showConclusion();
        }
    }

    setStep() {
        this.cheetIndex.innerText = this.active + 1;
        this.cheetMax.innerText = this.max;
        this.cheetRange.style.width = `${(100 / this.max) * (this.active + 1)}%`;
    }

    showConclusion() {
        const values = {
            yes: 0,
            no: 0,
            maybe: 0,
        };

        const checked = Array.from(this.elem.querySelectorAll('[type="radio"]:checked'));

        checked.forEach((elem) => {
            // eslint-disable-next-line no-plusplus
            values[elem.value]++;
        });

        this.cheetNo.innerText = `${((100 / checked.length) * values.no).toFixed(2)}%`;
        this.cheetNo.style.width = `${((100 / checked.length) * values.no).toFixed(2)}%`;

        this.cheetMaybe.innerText = `${((100 / checked.length) * values.maybe).toFixed(2)}%`;
        this.cheetMaybe.style.width = `${((100 / checked.length) * values.maybe).toFixed(2)}%`;

        this.cheetYes.innerText = `${((100 / checked.length) * values.yes).toFixed(2)}%`;
        this.cheetYes.style.width = `${((100 / checked.length) * values.yes).toFixed(2)}%`;

        this.cheetAction.classList.add('d-none');
        this.cheetConclusion.classList.remove('d-none');
    }

    enableNext() {
        this.cheetNext.classList.remove('disabled');
    }

    disableNext() {
        this.cheetNext.classList.add('disabled');
    }

    enableBack() {
        this.cheetBack.classList.add('disabled');
    }

    disableBack() {
        this.cheetBack.classList.remove('disabled');
    }
}
